import React, { Component } from 'react'
import PropTypes from 'prop-types';
// import { Group, KeypadOption, NoInfo, UserList } from '../styles/dialpadstyle';
// import { RecentList } from './dialpad'
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'modules/theme';

export class OnlineScreenTheme extends Component {

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  getTypeUrl(type = "") {
    if (type == 'Inbound' || type == 'Missed') {
      return '/images/missed-call.png';
    }
    return '/images/outgoing-call.png';
  }
  render() {

    const { btnCall, btnKeypad, onNumberKeyPress, onNumberChange, onCall, callList, callProcess } = this.props;
    return (
      // <span style={{ width: '100%', display: 'block' }}>
      //   <Group>
      //     <KeypadOption style={{ position: 'relative', width: '88%' }}>
      //       <FormWrapper>
      //         {/* <FormColumn></FormColumn> */}
      //         <FormColumn>
      //           {this.renderFormGroup('', {
      //             type: 'tel',
      //             defaultValue: '',
      //             placeholder: 'Search Number',
      //             autoFocus: false,
      //             required: true,
      //             id: 'number',
      //             value: this.props.number,
      //             onKeyPress: onNumberKeyPress,
      //             // onChange: onNumberChanges,
      //             onChange: onNumberChange
      //           })}
      //         </FormColumn>
      //       </FormWrapper>
      //       <Button
      //         btnStyle="link"
      //         type="simple"
      //       >
      //         <img src={btnCall} style={{ width: '38px' }} onClick={onCall} />
      //       </Button>
      //     </KeypadOption>
      //     <Button
      //       btnStyle="link"
      //       type="simple"
      //       style={{ right: '-3px' }}
      //     >
      //       <img src={btnKeypad} style={{ width: '38px' }} />
      //     </Button>
      //   </Group>
      //   <UserList>
      //     {
      //       callList && callList.length ?
      //         (
      //           <React.Fragment>
      //             {callList.map(data => {
      //               return (
      //                 <RecentList
      //                   image={this.getTypeUrl(data.type)}
      //                   name={data.name}
      //                   message={data.message}
      //                   time={data.time}
      //                   dialNumber={callProcess}
      //                   callInfo={data}
      //                 />
      //               );
      //             })}
      //           </React.Fragment>
      //         ) :
      //         <NoInfo>
      //           <img src="images/clock_history.png" />
      //           <span>Your call history in empty</span>
      //           <h4>No Call History</h4>
      //         </NoInfo>
      //     }
      //   </UserList>
      // </span>
      <React.Fragment></React.Fragment>
    )
  }
}

OnlineScreenTheme.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

OnlineScreenTheme.contextTypes = {
  __: PropTypes.func
};

export default OnlineScreenTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/OnlineScreenTheme.js